import { render, staticRenderFns } from "./MasterItemGroup.vue?vue&type=template&id=5dfb3923&scoped=true"
import script from "./MasterItemGroup.vue?vue&type=script&lang=js"
export * from "./MasterItemGroup.vue?vue&type=script&lang=js"
import style0 from "./MasterItemGroup.vue?vue&type=style&index=0&id=5dfb3923&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfb3923",
  null
  
)

export default component.exports